.th {
  --ixf-table-resizer-size: 2px;

  position: relative;
  display: block;
  color: var(--ixf-color-neutral-dk);
  font-weight: var(--ixf-font-weight-main-medium);
  font-size: 0.75rem;
  height: 24px;
  line-height: 0.875rem;

  &:focus {
    outline: none;
  }

  .content {
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    width: 100%;
    padding: calc(var(--ixf-table-header-cell-spacing-vertical) + 1px)
      var(--ixf-table-header-cell-spacing-horizontal);

    .columnName {
      flex: 1;

      &.align {
        &-left {
          text-align: left;
        }

        &-center {
          text-align: center;
        }

        &-right {
          text-align: right;
        }
      }
    }
  }

  .resizer {
    background: var(--ixf-table-border-color);
    position: absolute;
    top: 0;
    right: calc(var(--ixf-table-resizer-size) / -2);
    z-index: 1;
    width: var(--ixf-table-resizer-size);
    height: 100%;
    cursor: col-resize;
    user-select: none;
    touch-action: none;
    opacity: 0;
    transition: ease-in 150ms;

    &.isResizing {
      background: var(--ixf-text-tone-md);
      opacity: 1;
    }
  }

  &:last-child {
    .resizer {
      display: none;
    }
  }

  &.isPinnedLeft,
  &.isPinnedRight {
    background: var(--ixf-table-background-color);
    position: sticky;
    top: 0;
    z-index: 2;
  }

  &.isPinnedLeft {
    left: 0;
    border-right: var(--ixf-table-header-border);
    box-shadow: var(--ixf-table-pinned-column-left-box-shadow);

    + .th {
      border-left: none;
    }
  }

  &.isPinnedRight {
    right: 0;
    border-left: var(--ixf-table-header-border);
    box-shadow: var(--ixf-table-pinned-column-right-box-shadow);
  }

  &:not(:first-child) {
    border-left: var(--ixf-table-header-border);
  }

  &.isDragging {
    background: var(--ixf-color-background);
    user-select: none;
    touch-action: none;
    flex-grow: 0;
    z-index: 1;

    .resizer {
      display: none;
    }
  }

  &.isReorderingToLast {
    border-left: var(--ixf-table-header-border);
    border-right: transparent;
    flex: 1;
  }

  &.isReordering {
    touch-action: none;

    .resizer {
      display: none;
    }
  }
}
